<template>
  <v-dialog
    :width="$vuetify.breakpoint.smAndUp ? '60%':'80%'"
    v-model="bActive">
    <!-- Start content -->
    <v-card
      class="reserve-dialog-wrapper">
      <p
        class="reserve-dialog-title">
        Solicita tu reservación
      </p>
      <v-layout
        row
        wrap>
        <v-flex
          class="flex-reserve-actions"
          xs12
          sm12
          md12>
          <v-text-field
            hide-details
            label="Corre electrónico"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex
          class="flex-reserve-actions"
          xs12
          sm6
          md6>
          <v-text-field
            hide-details
            label="Nombre completo"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex
          class="flex-reserve-actions"
          xs12
          sm6
          md6>
          <v-text-field
            hide-details
            label="Teléfono"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex
          class="flex-reserve-actions"
          xs12
          sm12
          md12>
          <v-textarea
            rows="3"
            hide-details
            label="Descripción de problema y síntomas"
            clearable
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout
        wrap
        row
        justify-center>
        <v-flex
          class="flex-reserve-actions"
          sm2
          md2
          xs2>
          <v-btn
            @click="bActive = false"
            color="#4E66FF"
            class="reserve-button"
            block>
            <v-icon
              style="color: white !important">
              mdi-close
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          class="flex-reserve-actions"
          sm10
          md10
          xs10>
          <v-btn
            color="#4E66FF"
            class="reserve-button"
            block>
            <p
              class="button-reserve-text">
              Confirmar
            </p>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- End content -->
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    bActive: false
  }),
  watch: {
    bActive: function (val) {
      if (!val) {
         this.$store.commit('setReservation', false)
      }
    },
    bReserve: function (val) {
      if (val) {
        this.bActive =  true;
      }
    },
  },
  methods: {
    setReservation (val) {
      this.$store.commit('setReservation', val)
    }
  },
  computed: {
    bReserve () {
      return this.$store.state.bReserve
    }
  }
}
</script>
<style 
  scoped>
  .flex-reserve-actions {
    padding: 10px;
  }
  .reserve-button {
  }
  .button-reserve-text {
    text-transform: none !important;
    font-weight: bold;
    text-align: center;
    font-family: 'Raleway', sans-serif;
    font-size: 20px;
    color:  white !important;
  }
  .reserve-dialog-title {
    margin-bottom: 20px;
    text-align: center;
    font-family: 'Raleway', sans-serif;
    font-weight: 600;
    font-size: 30px;
    color:  #282828;
  }
  .reserve-dialog-wrapper {
    width: 100%;
    height: 100%;
    padding: 15px;
    padding-right: 30px;
    padding-left: 30px;
  }
</style>